export function getGracePeriod(period: string) {
	const splittedPeriod = period.split(' ');
	const time = splittedPeriod[splittedPeriod.length - 2];
	const suffix = splittedPeriod[splittedPeriod.length - 1];
	const formattedPeriod = `${time} ${suffix}`;
	return formattedPeriod;
}
